import '../input/button-input';

import { LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('main-nav')
export class MainNav extends LitElement {

	// Props
	@state()
	_slotNodes: Node[] = [];

	// Lifecycle Hooks

	firstUpdated() {

		// add classes
		this.classList.add('MainNav');

		// slots
		const slot: HTMLElement | null = this.querySelector('[slot="body"]');
		if (slot) {
			this._slotNodes = Array.from(slot.childNodes);
			this._slotNodes.forEach((node) => {
				this.appendChild(node);
			});
		}

		// observer
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.target == this) {
					if (entry.intersectionRatio == 0) {
						document.dispatchEvent(new Event('navhidden'));
					} else {
						document.dispatchEvent(new Event('navvisible'));
					}
					
				}
			});
		}, { rootMargin: `${screen.height}px` });
		observer.observe(this);
	}

	createRenderRoot() { 
		return this;
	}

}